import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';

@Injectable({
    providedIn: 'root'
})
export class DocumentsListService {
    constructor(private configService: ConfigurationService, private http: HttpClient) { }

    getDocumentsList(userId: string) {
        const documentsApiUrl = this.configService.getConfig()?.shell.api.documentsApiUrl;

        return firstValueFrom(this.http.get(documentsApiUrl + 'documents/' + userId));
    }
}
